module.exports = __webpack_public_path__ + "img/Error400.9a27d488.png";